import { ListboxField_default } from "./chunk-UBMBACJO.js";
import { Listbox_Option_default } from "./chunk-NWTCAASI.js";

// src/components/ListboxField/index.tsx
var ListboxFieldComponent = ListboxField_default;
ListboxFieldComponent.Option = Listbox_Option_default;
ListboxFieldComponent.Option.displayName = "ListboxField.Option";
export { ListboxFieldComponent };